(function() {
    'use strict';
    angular
        .module('valueconnectApp')
        .factory('BrokerageRegion', BrokerageRegion);

    BrokerageRegion.$inject = ['$resource'];

    function BrokerageRegion ($resource) {
        var resourceUrl =  'api/brokerage-regions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getDropDownBrokerageRegions': { method:'GET', url:'api/brokerage-regions-minimal', isArray: true }
        });
    }
})();
